.region {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: min(360px, calc(100vw - 40px));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: 13px 16px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-bg-elevated);
  box-shadow: var(--shadow-overlay);
  pointer-events: auto;
  animation: sr-toast-in 160ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.info {
  border-left: 3px solid var(--color-info);
}

.success {
  border-left: 3px solid var(--color-ok);
}

.error {
  border-left: 3px solid var(--color-error);
  background: var(--color-error-bg);
}

.message {
  flex: 1 1 auto;
  font-size: var(--fs-sm);
  color: var(--color-text);
  word-break: break-word;
}

.close {
  flex: 0 0 auto;
  background: transparent;
  border: none;
  color: var(--color-text-muted);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}

.close:hover {
  color: var(--color-text);
}

@media (max-width: 600px) {
  .region {
    left: 12px;
    right: 12px;
    bottom: calc(12px + env(safe-area-inset-bottom));
    max-width: none;
  }
}
